const themePrefix = 'vd';
window.themePrefix = 'vd';

/**
 * Basics // jquery & velocity
 */
window.jQuery = window.$ = require('jquery');
window.Velocity = require('velocity-animate');
require('velocity-ui-pack/velocity.ui.min');
window.Easings = require('./modules/velocity.easings');
require('./modules/t3kk.jquery');

require('./modules/modernizr-custom');
require('./modules/_lazyLoading');

import * as NProgress from 'nprogress';

import * as T3_Ajax from './modules/t3/_ajax';
import * as Loader from './elements/_loader';

/**
 * Functions
 */
import { dataAttributeIsTrue, isset } from './func/_general';
import { scroll__to_anchor, scroll__to_first_content_element } from './func/_scroll';

/**
 * Modules
 */
import * as Survey from 'SurveyJs/modules/_survey';

import * as SurveyChart from 'SurveyJs/modules/_chart';
import * as SurveyDownload from 'SurveyJs/modules/_download';
import * as SurveyFeedback from 'SurveyJs/modules/_feedback';
import * as SurveyForm from 'SurveyJs/modules/_form';

import * as Device from './modules/_device';
import * as Theme from './modules/_theme';

/**
 * Modules for page sections
 */
import * as Header from './section/_header';

/**
 * Elements
 */
import './elements/_accordion';

const init = () => {
  NProgress.start();
};



const init__onReady = () => {
  NProgress.done();
  $('html').removeClass('no-scrollbar');
  $('.body__container').removeClass('fixFooter');

  init__responsiveness();

  init__survey();
};

const init__responsiveness = () => {
  if (!Device.is__mobile()) {
  } else {
  }
};

const init__survey = () => {
  if ($('body').hasClass('template--Surveysummary')) {
    function initDownloads() {
      SurveyDownload.initDownloads();
    }
    Survey.loadSummary($('main > .vd-wrapper'), initDownloads);
  }

  Survey.initAnswers();
  Survey.initProgressGraphic();
  SurveyFeedback.init();
  SurveyForm.init();

  //SurveyDownload.init();

  /**
   * on click actions for Survey modules
   */
  Survey.actions();
  //SurveyDownload.actions();
  SurveyForm.actions();
  SurveyFeedback.actions();

  /**
   * events for Survey modules
   */
  SurveyForm.events();

  /**
   * Survey form
   */
  if ($('.vd-form.vd-form--survey-contact').length > 0) {
    const sessionData = Survey.getSessionData(
      $('.vd-form__actions .vd-btn[data-action="complete"]')
    );

    SurveyForm.validate();
  }
};

const init__onScroll = () => {};

/**
 * execute
 */

init();

$(function () {
  init__onReady();
  fixFooter();
});

$(window).scrolled(function () {
  init__onScroll();
});

const fixFooter = () => {
  const heightDevice = Device.get__window_height();

  const heightHeader = $('.body__container > header').outerHeight();
  const heightMain = $('.body__container > main').outerHeight();
  const heightFooter = $('.body__container > footer').outerHeight();

  if (heightHeader + heightMain < heightDevice - heightFooter) {
    $('body').addClass('fixFooter');
  } else {
  }
};
